module.exports = __webpack_public_path__ + "static/media/RobotoMono-SemiBold.eabbacb6.ttf";